module.exports = __webpack_public_path__ + "static/img/icon_left.a1b0c876.png";